export default "__VITE_ASSET__LlszlVoM__"